import logger from "@/utils/logger.js";
import axios from "axios";
import { EntityModel } from "@/models/EntityModel.js";
import { checkToken } from '@/utils/lambdaUtils';
import { useAuthStore } from '@/stores/authStore';
import api from "@/services/api.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/entities/';

export const getEntities = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new EntityModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting entity list', error);
    }
};

export const getAllEntities = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}all`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new EntityModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting all entities', error);
    }
};

export const updateEntity = async (entity) => {
    try {
        await checkToken();
        // Accept plain objects too by coercing to EntityModel
        const entityInstance = entity instanceof EntityModel ? entity : new EntityModel(entity);

        if (!(entityInstance instanceof EntityModel)) {
            throw new Error('updateEntity() entity called with incorrect parameters.');
        }
        if (!entityInstance.id || !entityInstance.name || !entityInstance.type || !entityInstance.status) {
            throw new Error('updateEntity() entity called while missing required parameters');
        }

        // Ensure numeric values are sent as numbers
        entityInstance.id = parseInt(entityInstance.id);

        await checkToken();
        const response = await api.put(`${baseUrl}`, entityInstance, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        logger.error('Error updating entity', error);
        throw error;
    }
};

export const createEntity = async (entity) => {
    try {
        await checkToken();
        if (!(entity instanceof EntityModel)) {
            throw new Error('createEntity() entity called with incorrect parameters.');
        }

        await checkToken();
        const response = await api.post(`${baseUrl}`, entity, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        logger.error('Error creating entity', error);
        throw error;
    }
};